import React from "react";
import RequestDetailModal from "./RequestDetailModal";

const OapiModal = (props) => <RequestDetailModal {...props} />;

export default OapiModal;
